/**
 * 延迟指定毫秒数的异步函数
 * @param ms 延迟的毫秒数
 * @returns Promise<void>
 */
export const sleep = (ms: number): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export default sleep